// The undo / redo keyboard shortcut of an event: Ctrl or Cmd with Z (undo), Y or Shift+Z (redo). Alt makes it
// something else, so it is ignored. Shared by the toolbar and the table cells.
export function historyShortcut(event) {
  if (!(event.ctrlKey || event.metaKey) || event.altKey) return null;
  const key = String(event.key).toLowerCase();
  if (key === "y") return "redo";
  if (key === "z") return event.shiftKey ? "redo" : "undo";
  return null;
}
